module.exports = __webpack_public_path__ + "be5ec716fd4990e5b96ce300f7fa3900.png";